import { ArrowRight, Building2, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import AuthFrame from '../../components/layout/AuthFrame';

const organisationCapabilities = [
  'Account value pyramids and strategic priorities',
  'Evidence-led pain hypotheses and use cases',
  'Stakeholder-specific email, LinkedIn and call messaging',
  'Multi-user team access and account collaboration',
  'Shared territory and opportunity visibility',
  'Central organisation configuration',
  'Administrative user and tenant branding controls',
];

export default function Signup() {
  return (
    <AuthFrame eyebrow="Organisation access" title="Request access" description="Heymakr workspaces are provisioned for each organisation so account intelligence, methodologies and controls remain properly governed.">
      <div className="app-panel overflow-hidden">
        <div className="flex items-center gap-3 border-b border-app-line p-5">
          <div className="flex h-10 w-10 items-center justify-center bg-app-accent text-app-accent-text">
            <Building2 className="h-5 w-5" aria-hidden="true" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-app-ink">Organisation workspace</h2>
            <p className="mt-0.5 text-xs text-app-muted">Configured around your team and sales process</p>
          </div>
        </div>
        <ul className="space-y-3 p-5" aria-label="Workspace capabilities">
          {organisationCapabilities.map(capability => (
            <li key={capability} className="flex items-start gap-3 text-sm leading-6 text-app-muted">
              <Check className="mt-1 h-4 w-4 shrink-0 text-app-positive" aria-hidden="true" />
              <span>{capability}</span>
            </li>
          ))}
        </ul>
        <div className="border-t border-app-line p-5">
          <Link to="/signup/organisation" className="btn-primary w-full gap-2">Request organisation access <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
        </div>
      </div>
      <p className="mt-8 flex flex-wrap items-center gap-x-2 text-sm text-app-muted">Already have an account? <Link to="/login" className="inline-flex min-h-10 items-center font-semibold text-app-ink underline decoration-app-line-strong underline-offset-4 hover:decoration-app-ink">Sign in</Link></p>
    </AuthFrame>
  );
}
